import { Footer } from "./Footer";
import { Good } from "./Good";
import { Home } from "./Home";
import { Shop } from "./Shop";

export const LangEn = {
    direction: 'ltr',
    Home: Home,
    Shop: Shop,
    Footer: Footer,
    Good: Good
}